import React from 'react';

const ImageGridItem = ({ imageUrl, isSelected, onClick }) => {
  const itemStyle = {
    width: '120px',
    height: '120px',
    border: isSelected ? "3px solid var(--ui-primary)" : "1px solid var(--ui-border)", // Highlight if selected
    borderRadius: '4px',
    overflow: 'hidden',
    cursor: 'pointer',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: "var(--ui-surface-muted)",
  };

  const imgStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover', // Ensures image covers the area, cropping if necessary
  };

  const selectedOverlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 123, 255, 0.3)', // Semi-transparent blue overlay
    display: isSelected ? 'flex' : 'none',
    justifyContent: 'center',
    alignItems: 'center',
    color: "var(--ui-on-primary)",
    fontSize: '30px',
    fontWeight: 'bold',
  };

  return (
    <div style={itemStyle} onClick={() => onClick(imageUrl)}>
      <img src={imageUrl} alt="Gallery Item" style={imgStyle} />
      <div style={selectedOverlayStyle}>
        ✔
      </div>
    </div>
  );
};

export default ImageGridItem;